import { createFileRoute } from "@tanstack/react-router";
import AdminSubscriptionsPage from "@/components/admin/admin-subscriptions-page";

export const Route = createFileRoute("/_app/admin/subscriptions/")({
	component: AdminSubscriptionsPage,
});
